import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { FindActiveDropStageFragment } from "../utils"

export const MintTableRowCollectionFragment = graphql(
  `
    fragment MintTableRowCollection on Collection {
      ...CollectionLockup
      imageUrl
    }
  `,
  [CollectionLockupFragment],
)

export const MintTableRowDropFragment = graphql(
  `
    fragment MintTableRowDrop on Drop {
      __typename
      ...findActiveDropStage
      stages {
        __typename
        ... on Erc1155SeaDropV2Stage {
          fromTokenId
          toTokenId
        }
      }
      ... on Erc1155SeaDropV2 {
        tokenMintDetails {
          tokenId
          groupName
          groupValue
          imageUrl
        }
      }
    }
  `,
  [FindActiveDropStageFragment],
)
